import axios from '@/plugins/axios/https';
import lo_ from '@/plugins/lodash.js';

export function ApiGetOverviewCharts() {
  return axios.get('/team/overview/charts/');
}

export function ApiGetDashboards() {
  return axios.get('/team/dashboards/');
}

export function ApiGetDashboardDetial(uuid) {
  return axios.get(`/team/dashboards/${uuid}/`);
}

export function ApiHideDashboardLists({ dashboardId, dhartUuid }) {
  return axios.put(`/team/dashboards/${dashboardId}/charts/${dhartUuid}/hide/`);
}

export function ApiShowDashboardLists({ dashboardId, dhartUuid }) {
  return axios.put(`/team/dashboards/${dashboardId}/charts/${dhartUuid}/show/`);
}

export function ApiEditDashboardName({ uuid, name }) {
  const form = {
    name
  };
  return axios.put(`/team/dashboards/${uuid}/rename/`, form);
}

export function ApiGetMemberLists({
  search,
  limit,
  offset,
  joinDatetimeLte,
  joinDatetimeGte,
  ordering
}) {
  const order = lo_.snakeCase(ordering.order);
  const form = {
    limit,
    offset,
    ordering: ordering.sort === 'asc' ? order : `-${order}`
  };

  if (search) {
    form.search = search;
  }

  const date =
    joinDatetimeLte && joinDatetimeGte
      ? `&join_datetime__lte=${joinDatetimeLte}&join_datetime__gte=${joinDatetimeGte}`
      : '';

  return axios.get(`/team/clientbases/?${date}`, form);
}

export function ApiBlockClientSmsOrMail({ blockType, isBlocked, clientbaseUniqid }) {
  const form = {
    clientbaseUniqid
  };
  return axios.put(`/team/clientbases/block/${isBlocked}/${blockType}/`, form, {
    loading: false
  });
}

export function ApiGetMemberDetial({ limit, offset, uniqId }) {
  const form = {
    limit,
    offset
  };

  return axios.get(`/team/clientbases/${uniqId}/events/`, form, {
    loading: false
  });
}

export function ApiGetMemberProfile(uniqId) {
  return axios.get(`/team/clientbases/${uniqId}/profile/`);
}

export function ApiGetMemberBaseProfile(uniqId) {
  const form = {};

  return axios.get(`/team/clientbases/${uniqId}/basic/profile/`, form, {
    loading: false
  });
}

export function ApiPermissionsCurrent() {
  return axios.get('/team/members/permissions/current/');
}

export function ApiGetPermissionsBoard() {
  return axios.get('/team/members/permissions/board/');
}

export function ApiEditPermission({ hasPermission, contentType, action }) {
  const form = {};
  return axios.put(
    `/team/members/permissions/current/${action}/${contentType}/${hasPermission}/`,
    form,
    {
      loading: false
    }
  );
}
